import React, {useState} from 'react';
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { auth } from '../firebase'
import { navigate } from "@reach/router"


const SignIn = (props) => {
   
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    
    const onEmailChange = (event) =>{setEmail(event.target.value)}
    const onPasswordChange = (event) =>{setPassword(event.target.value)}
    
    const onBtnClick = () =>{
        auth.signInWithEmailAndPassword(email, password)
            .then(function (result) {
                setEmail('')
                setPassword('')
                navigate('/AllOrders')
            })
            .catch(function(error) {
                // Handle Errors here.
                var errorCode = error.code;
                var errorMessage = error.message;
                // ...
                /***************************Add Error Handling!!!***************************** */
            });
    }
    

    


    return(
        <div className="sign_up_container container border-dark" style={{marginTop:"2rem" ,paddingTop:"1rem", backgroundColor:"#eee", paddingBottom:"3rem"}}>
            <div className="page_header_container">
                <h1>Sign In</h1>
                <hr />
            </div>
            <div className = "signup_body_container">
                <div className = "signup_form_wrapper">
                <Form>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>Email address</Form.Label>
                            <Form.Control type="email" placeholder="Enter email" value={email} onChange={onEmailChange} />
                            <Form.Text className="text-muted">
                            We'll never share your email with anyone else.
                            </Form.Text>
                        </Form.Group>

                        <Form.Group controlId="formBasicPassword">
                            <Form.Label>Password</Form.Label>
                            <Form.Control type="password" placeholder="Password" value={password} onChange={onPasswordChange} />
                        </Form.Group>
                        <Form.Group controlId="formBasicCheckbox">
                            <Form.Check type="checkbox" label="Keep me logged in!" />
                        </Form.Group>
                        
                        
                        <Button variant="primary" onClick={onBtnClick} >
                            Sign In
                        </Button>

                        <Button href="/Home" variant="link">.</Button>
                        
                    </Form>
                </div>
            </div>
        </div>
    )
}

export default SignIn;